<div class="error-display" 
     [class.mode-card]="mode === 'card'" 
     [class.mode-inline]="mode === 'inline'"
     [class.mode-banner]="mode === 'banner'"
     [class.type-error]="type === 'error'"
     [class.type-warning]="type === 'warning'"
     [class.type-info]="type === 'info'"
     [class.type-network]="type === 'network'">
  
  @if (mode === 'card') {
    <mat-card class="error-card">
      <mat-card-content>
        <div class="error-content">
          <div class="error-icon-container">
            <mat-icon class="error-icon">{{ displayIcon }}</mat-icon>
          </div>
          
          <div class="error-text">
            <h3 class="error-title">{{ displayTitle }}</h3>
            <p class="error-message">{{ message }}</p>
            
            @if (details) {
              <button mat-button class="details-toggle" (click)="toggleDetails()">
                <mat-icon>{{ showDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
                {{ showDetails ? 'Masquer les détails' : 'Afficher les détails' }}
              </button>
              
              @if (showDetails) {
                <div class="error-details">
                  <pre>{{ details }}</pre>
                </div>
              }
            }
          </div>
        </div>
      </mat-card-content>
      
      <mat-card-actions class="error-actions">
        @if (showRetry) {
          <button mat-raised-button color="primary" (click)="onRetry()">
            <mat-icon matButtonIcon>refresh</mat-icon>
            Réessayer
          </button>
        }
        @if (showDismiss) {
          <button mat-button (click)="onDismiss()">
            Fermer
          </button>
        }
      </mat-card-actions>
    </mat-card>
  }
  
  @if (mode === 'inline') {
    <div class="error-inline">
      <mat-icon class="inline-icon">{{ displayIcon }}</mat-icon>
      <div class="inline-content">
        <span class="inline-message">{{ message }}</span>
        @if (details) {
          <button mat-button class="details-toggle-inline" (click)="toggleDetails()">
            {{ showDetails ? 'Moins' : 'Plus' }}
          </button>
        }
      </div>
      
      @if (showRetry) {
        <button mat-icon-button class="inline-retry" (click)="onRetry()" title="Réessayer">
          <mat-icon>refresh</mat-icon>
        </button>
      }
      @if (showDismiss) {
        <button mat-icon-button class="inline-dismiss" (click)="onDismiss()" title="Fermer">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    
    @if (showDetails && details) {
      <div class="error-details-inline">
        <pre>{{ details }}</pre>
      </div>
    }
  }
  
  @if (mode === 'banner') {
    <div class="error-banner">
      <div class="banner-content">
        <mat-icon class="banner-icon">{{ displayIcon }}</mat-icon>
        <div class="banner-text">
          <strong>{{ displayTitle }}</strong>
          <span>{{ message }}</span>
        </div>
      </div>
      
      <div class="banner-actions">
        @if (showRetry) {
          <button mat-button (click)="onRetry()">
            <mat-icon matButtonIcon>refresh</mat-icon>
            Réessayer
          </button>
        }
        @if (showDismiss) {
          <button mat-icon-button (click)="onDismiss()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>
  }
</div>
